import {
  Exemption,
  ExemptionAttachmentUploadCommand,
  ExemptionAttachmentDeleteCommand
} from '@portbase/bezoekschip-service-typescriptmodels';
import {
  toBase64
} from '../../../../../common/upload/upload.utils';
import {sendCommand, sendCommandAndWait} from "../../../../../common/utils";
import {AppContext} from "../../../../../app-context";
import {VisitContext} from "../../../../visit-context";

export function uploadExemptionAttachments(this: any, exemption: Exemption, files: File[] | FileList | null) {

  const listOfFiles = files ? Array.from(files) : [];

  listOfFiles.forEach(async (file, index) => {

    this.uploadedExemptionFileName = file.name;

    if (!isDocxFile(file) &&
        !isPdfFile(file)) {
      AppContext.registerError('Exemption attachment "'+ this.uploadedExemptionFileName +'" could not be uploaded, not a docx or pdf file.')
      return;
    }

    this.uploadedExemptionFileContent = await toBase64(file).toPromise();

    console.log(this.uploadedExemptionFileContent)

    const exemptionAttachmentUploadCommand = <ExemptionAttachmentUploadCommand> {
      crn: VisitContext.visit.crn,
      berthVisitId: exemption.berthVisitId,
      exemptionId: exemption.id,
      exemptionType: exemption.exemptionType,
      fileName: this.uploadedExemptionFileName,
      fileContent: this.uploadedExemptionFileContent
    };

    // Post files to be stored
    sendCommandAndWait('com.portbase.bezoekschip.common.api.exemptions.ExemptionAttachmentUploadCommand',
      exemptionAttachmentUploadCommand).subscribe(result => {
      if (result && result === exemptionAttachmentUploadCommand.fileName) {
        AppContext.registerSuccess('Exemption attachment "'+ exemptionAttachmentUploadCommand.fileName +'" was uploaded successfully.')
        exemption.attachmentLastEdited = Date.now().toString();
        if(!exemption.attachments.includes(exemptionAttachmentUploadCommand.fileName)) {
          exemption.attachments.push(exemptionAttachmentUploadCommand.fileName);
        }
      } else {
        AppContext.registerError('Exemption attachment "'+ exemptionAttachmentUploadCommand.fileName +'" could not be uploaded.')
      }
    });
  });
}

export function deleteExemptionAttachment(exemption: Exemption, index: number) {

  const deletedFileName = exemption.attachments[index];
  exemption.attachments.splice(index, 1);
  exemption.attachmentLastEdited = Date.now().toString();

  const exemptionAttachmentDeleteCommand = <ExemptionAttachmentDeleteCommand> {
    crn: VisitContext.visit.crn,
    berthVisitId: exemption.berthVisitId,
    exemptionId: exemption.id,
    exemptionType: exemption.exemptionType,
    fileName: deletedFileName
  };

  sendCommand('com.portbase.bezoekschip.common.api.exemptions.ExemptionAttachmentDeleteCommand', exemptionAttachmentDeleteCommand);
}

function isDocxFile(file: File): boolean {
  const mimeTypeCheck = "application/vnd.openxmlformats-officedocument.wordprocessingml.document" === file.type;
  const extensionCheck = file.name?.toLowerCase().endsWith(".docx");
  // Consider signature matching also
  return mimeTypeCheck && extensionCheck;
}

function isPdfFile(file: File): boolean {
  const mimeTypeCheck = "application/pdf" === file.type;
  const extensionCheck = file.name?.toLowerCase().endsWith(".pdf");
  // Consider signature matching also
  return mimeTypeCheck && extensionCheck;
}
